export default __webpack_public_path__ + "static/media/P330_RoHS.819a4e8f.pdf";